import { useUILayerStore } from '@_shared/stores/useUILayerStore';

import { FolderOptionsModal } from '../ui';
import { useFolderAction } from './useFolderAction';
import { useFolderDeletePopup } from './useFolderDeletePopup';
import { useFolderNameUpdatePopup } from './useFolderNameUpdatePopup';

interface IProps {
	folderId: string;
}

export function useFolderOptionsModal({ folderId }: IProps) {
	const { getFolderName } = useFolderAction();
	const folderName = getFolderName(Number(folderId));

	const { pushLayer } = useUILayerStore();

	const { openFolderNameUpdatePopup } = useFolderNameUpdatePopup({
		folderId,
		initialFolderName: folderName,
	});

	const { openFolderDeletePopup } = useFolderDeletePopup({ folderId, isFolderListPage: false });

	function openFolderOptionsModal() {
		pushLayer(
			'modal',
			<FolderOptionsModal
				openFolderNameUpdatePopup={openFolderNameUpdatePopup}
				openFolderDeletePopup={openFolderDeletePopup}
			/>,
		);
	}

	return {
		openFolderOptionsModal,
	};
}
